import { reactive, toRefs, onMounted, watch, nextTick, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getEWShopDetailBySpuId } from '@/api/directSales'
import { showToast } from '@/util/couponCollection'
import _ from 'lodash'

export default function useShopDetail() {
  const store = useStore()
  const router = useRouter()
  const state = reactive({
    detailArr: [],
    slideList: [],
    dblclickImage: [],
    detailData: {},
    currentSkuLis: [], //受gscode影响
    allSkuLis: [],
    isEnterShoppingCar: false,
    isEnable: false, //计划是否生效中--true
    applyDealerParam: {},
    selectShopVariantItem: {},
    skuItem: {},
    isChecking: false
  })
  // 获取详情信息
  const getShopDetailFn = async params => {
    state.detailArr = params
    if (!params.spuId) return
    store.commit('SETSPUID', params.spuId)
    try {
      const data = await getEWShopDetailBySpuId(params.spuId, params)
      data.skuList = data.skuList.map(sku => {
        return {
          ...sku,
          skuId: sku.id,
          price: sku.otrPriceUpdateFlag === 'Y' ? sku.dealerPrice : sku.suggestPrice,
          description: sku.description1,
          useDescription: sku.description2
        }
      })
      data.salesAttributes = data.salesAttributes.map(att => {
        return {
          ...att,
          values: att.values.map(value => {
            return {
              lable: value,
              code: value,
              disable: _.find(data.skuList, sku => sku[att.code] === value) ? false : true
            }
          })
        }
      })
      state.detailData = data
      state.isEnterShoppingCar = true
      state.isEnable = true
      state.slideList = data.banners
      state.dblclickImage = data.banners
      state.allSkuLis = data.skuList
      state.currentSkuLis = data.skuList || []
      let skuTemp = {}
      const selectShopVariantItem = {}
      if (data.skuList?.length === 1) {
        for (let index = 0; index < data.salesAttributes.length; index++) {
          const item = data.salesAttributes[index]
          // selected item from only sku
          const selectedValue = data.skuList[0][item.code]
          selectShopVariantItem[item.code] = { code: selectedValue, lable: selectedValue, pName: item.name, pid: item.code }
        }
        state.currentSkuLis = data.skuList
        store.commit('SETSkUITEM', { ...data.skuList[0] })
      } else {
        for (let index = 0; index < data.salesAttributes.length; index++) {
          const item = data.salesAttributes[index]
          selectShopVariantItem[item.code] = ''
          if (item.code === 'salesAttributeServiceContent') {
            const defaultSelectedValue = _.find(item.values, ele => ele.code === '整车' && !ele.disable)
            if (defaultSelectedValue) {
              selectShopVariantItem[item.code] = { code: defaultSelectedValue.code, lable: defaultSelectedValue.code, pName: item.name, pid: item.code }
            }
          }
        }
        if (params.skuId) {
          skuTemp = data.skuList.find(sku => sku.skuId === params.skuId)
          if (skuTemp) {
            for (let index = 0; index < data.salesAttributes.length; index++) {
              const item = data.salesAttributes[index]
              let itemCode = skuTemp[item.code]
              let target = item.values.find(({ code }) => code === itemCode) || {}
              let { code = '', lable = '' } = target
              selectShopVariantItem[item.code] = { code, lable, pName: item.name, pid: item.code }
            }
            console.log('selectShopVariantItem', selectShopVariantItem)
            store.commit('SETSkUITEM', { ...skuTemp })
          }
        }
      }
      store.commit('SETSELECTSHOPVARIANTITEM', { ...selectShopVariantItem })
      store.commit('SETSELECTSHOPVARIANTITEMFIRST', { ...selectShopVariantItem, ...store.state.stepperOption })
      const loyaltyDealerInfo = store.state.loyaltyDealerInfo
      if (data?.carInfo) {
        const carList = store.state.myCarList
        const matchMyCar = carList.find(car => car.vin === data?.carInfo?.vin)
        _.set(data, 'carInfo', matchMyCar || data?.carInfo)
        store.dispatch('setCurrentCarInfo', data?.carInfo)
      }
      if (loyaltyDealerInfo) {
        state.applyDealerParam = {
          sign: 'ewShopDetail',
          skuId: '',
          gsCode: loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
        }
      }
      relocation()
    } catch (error) {
      if (error.statusCode === 40004) {
        showToast('二维码已失效', {
          defaultMsg: '获取二维码信息失败',
          type: 'fail',
          duration: 3000,
          position: 'middle',
          overlay: true,
          onOpened: () => {
            router.replace({ path: '/' })
          }
        })
      }
    }
  }
  const relocation = () => {
    setTimeout(() => {
      try {
        let { lat = '' } = store.state.position
        if (!lat) {
          console.log('shopDetail-relocation')
          store.dispatch('getLocation')
        }
      } catch (error) {
        console.log('shopDetail-getLocation-error', error)
      }
    }, 3000)
  }
  const getPrice = () => {
    const loyaltyDealerInfo = store.state.loyaltyDealerInfo
    const gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
    let displayPrice = gsCode ? state.detailData?.dealerPrice : state.detailData?.suggestPrice
    let skuPrice = store.state.skuItem?.price
    displayPrice = _.isNumber(displayPrice) ? displayPrice : '-'
    skuPrice = _.isNumber(skuPrice) ? skuPrice : '-'
    if (!gsCode) {
      return `厂商建议零售价 ¥${displayPrice} 起`
    }
    if (skuPrice !== '-') {
      return `零售价 ¥${skuPrice}`
    } else {
      return `零售价 ¥${displayPrice} 起`
    }
  }
  const shopPrice = computed(() => getPrice())

  const salesAttributesTxt = computed(() => {
    const salesAttributes = state.detailData?.salesAttributes || []
    const customerAttributesName = salesAttributes
      .map(({ name, code }) => {
        const item = store.state.selectShopVariantItem[code]
        return item && item.pName ? `${item.pName}:${item.lable}` : name
      })
      .join('; ')
    return customerAttributesName
  })

  const shopInfoDatas = computed(() => ({
    ...state.detailData,
    orderNo: state.detailArr?.orderNo,
    isShowStep: state.isEnable,
    max: state.max,
    currentSkuLis: state.currentSkuLis,
    isChecking: state.isChecking
  }))

  const mergeSkuItem = (_skuItem, _skuLis) => {
    let skuItem = _skuItem || store.state.skuItem
    const currentSkuLis = _skuLis || state.currentSkuLis
    const baseItem = currentSkuLis.find(item => item.skuId === skuItem.skuId) || {}
    if (skuItem && skuItem.skuId && baseItem?.skuId) {
      const tempItem = state.allSkuLis.find(item => item.skuId === skuItem.skuId)
      skuItem = { ...tempItem, ...baseItem, ...skuItem, price: baseItem.price, maxPurchaseAmount: baseItem.maxPurchaseAmount }
      store.commit('SETSkUITEM', skuItem)
      return skuItem
    }
    return false
  }

  const resetSelectShopVariantItem = (data, salesAttributesData) => {
    console.log('resetSelectShopVariantItem-----')
    let selectShopVariantItem = {}
    let salesAttributes = salesAttributesData || state.detailData.salesAttributes
    if (data) {
      for (let index = 0; index < salesAttributes.length; index++) {
        const item = salesAttributes[index]
        let selectCode = data[item.code]?.code || ''
        let selectLable = data[item.code]?.lable || ''
        selectShopVariantItem[item.code] = selectCode && selectLable ? { code: selectCode, lable: selectLable, pName: item.name, pid: item.code } : ''
      }
    } else {
      for (let index = 0; index < salesAttributes.length; index++) {
        const item = salesAttributes[index]
        selectShopVariantItem[item.code] = ''
      }
    }
    store.commit('SETSELECTSHOPVARIANTITEM', { ...selectShopVariantItem })
  }

  const hasDealer = computed(() => state.applyDealerParam && state.applyDealerParam.gsCode)
  const refreshPrice = async dealerInfo => {
    const gsCode = dealerInfo.gsCode || dealerInfo.gs_code
    const spuId = store.state.spuId
    const skuId = store.state.skuItem?.skuId
    state.applyDealerParam = {
      skuId,
      gsCode,
      sign: 'ewShopDetail'
    }
    state.isChecking = true
    const fin = state.detailArr.fin
    if (gsCode && spuId && fin) {
      try {
        const result = await getEWShopDetailBySpuId(spuId, {
          gsCode,
          fin,
          orderNo: state.detailArr?.orderNo
        })
        const res = result.skuList.map(sku => {
          return {
            ...sku,
            skuId: sku.id,
            price: sku.otrPriceUpdateFlag === 'Y' ? sku.dealerPrice : sku.suggestPrice,
            description: sku.description1,
            useDescription: sku.description2
          }
        })
        if (res?.length === 0) {
          showToast('所选经销商此商品可售为空')
          // store.commit('SETSELECTSHOPVARIANTITEM', {})
          resetSelectShopVariantItem()
          state.applyDealerParam = {
            skuId: '',
            gsCode,
            sign: 'ewShopDetail'
          }
          nextTick(() => {
            state.currentSkuLis = []
          })
        } else {
          // 检查范围：selectShopVariantItem是否在新的currentSkuLis范围内
          const _skuItem = store.state.skuItem
          const skuItem = mergeSkuItem(_skuItem, res)
          // 不在范围内，重置参数
          !skuItem && _skuItem && _skuItem?.skuId && resetSelectShopVariantItem()
          nextTick(() => {
            result.salesAttributes = result.salesAttributes.map(att => {
              return {
                ...att,
                values: att.values.map(value => {
                  return {
                    lable: value,
                    code: value
                  }
                })
              }
            })
            state.detailData = result
            state.currentSkuLis = res
          })
        }
        console.log('通过经销商gscode刷新currentSkuLis---', res?.length)
      } catch (error) {
        showToast('获取SKU价格失败')
        state.currentSkuLis = []
      } finally {
        state.isChecking = false
      }
    } else {
      // showToast('请选择销售经销商')
      state.isChecking = false
      state.currentSkuLis = []
    }
  }
  watch(
    () => store.state.loyaltyDealerInfo,
    async v => {
      refreshPrice(v)
    },
    { deep: true, immediate: false }
  )
  watch(
    () => store.state.selectShopVariantItem,
    v => {
      const keys = Object.keys(v)

      state.selectShopVariantItem = v
      if (keys && keys.length && keys.length === state.detailData?.salesAttributes?.length) {
        const skuItem = state.currentSkuLis.find(sku => keys.map(attr => sku[attr] === v[attr]['code']).every(item => item === true)) || {}
        if (skuItem?.skuId) {
          mergeSkuItem(skuItem)
        } else {
          store.commit('SETSkUITEM', skuItem)
        }
      }
    },
    { deep: true }
  )
  watch(
    () => store.state.skuItem,
    _.debounce(skuItem => {
      if (state.allSkuLis && state.allSkuLis.length) {
        const baseItem = state.allSkuLis.find(item => item.skuId === skuItem.skuId) || {}
        let skuItemTemp = { ...baseItem, ...skuItem }
        state.skuItem = skuItemTemp
        store.commit('SETSTEPPEROPTION', {
          ...store.state.stepperOption,
          max: skuItemTemp.maxPurchaseAmount == '-1' ? 999 : +skuItemTemp.maxPurchaseAmount || 0,
          min: skuItemTemp.minPurchaseAmount == '-1' ? 1 : +skuItemTemp.minPurchaseAmount || 1
        })
        state.isEnterShoppingCar = skuItemTemp?.cartFlag ? !!(skuItemTemp?.cartFlag === 'Y') : true
        let loyaltyDealerInfo = store.state.loyaltyDealerInfo
        state.applyDealerParam = {
          sign: 'ewShopDetail',
          skuId: skuItem?.skuId,
          gsCode: loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
        }
      }
    }, 300),
    { deep: true }
  )

  onMounted(async () => {})

  return {
    ...toRefs(state),
    getShopDetailFn,
    salesAttributesTxt,
    shopInfoDatas,
    hasDealer,
    shopPrice
  }
}
